import { writable } from 'svelte/store';

export const currentSizeStore = writable();
